module.exports = __webpack_public_path__ + "img/aya.c08c6eaa.jpg";